(ns practitest.frontend.project-fields-settings.main
  (:require [practitest.frontend.project-fields-settings.views :as views]
            [practitest.frontend.project-fields-settings.events :as events]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]))

(defn new []
  [views/project-field-form-page {:edit? false}])

(defn edit []
  [views/project-field-form-page {:edit? true}])

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:project-fields-settings/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:project-fields-settings/init-complete]))

(defn form-controller []
  {:stop (fn [_] (re-frame/dispatch [::events/reset-form-values]))})

(defn system-field-edit []
  [views/system-field-edit-page])

(defn system-field-form-controller []
  {:stop (fn [_] (re-frame/dispatch [::events/reset-system-field-form-values]))})
